import { SignIn } from "@clerk/clerk-react";
import { resolveAppUrl } from "../lib/url";
import { DevQuickSignIn } from "../components/dev/DevQuickSignIn";

// Localhost-only convenience: skip the email + 424242 dance during dev.
// `DevQuickSignIn` self-hides outside DEV builds + non-localhost hosts.
//
// `lexportal+clerk_test@example.com` is the canonical local-dev
// PLATFORM_ADMIN identity — it's the sole entry in
// `lexserver/.env.local`'s `LEXSERVER_DEV_PLATFORM_ADMIN_EMAILS`, so it
// gets the `platform.admin` scope at exchange time and clears the
// `RequirePlatformAdmin` gate. See ai-docs/login-credentials.md
// §"Dev-platform-admin allowlist".
//
// Do NOT use `lexdemo+clerk_test@example.com` here: it was deliberately
// removed from the platform-admin allowlist so it stays ORG_ADMIN of the
// Lexiun Demo workspace (for LexIDE). Signing into LexPortal as lexdemo
// now trips the silent platform-admin kick → bounce to /sign-in.
const DEV_USERS = [
  { label: "lexportal", identifier: "lexportal+clerk_test@example.com" },
];

export function SignInPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 dark:bg-slate-950">
      <div className="w-full max-w-md">
        <DevQuickSignIn users={DEV_USERS} />
        <SignIn
          routing="path"
          path={resolveAppUrl("/sign-in")}
          signUpUrl={resolveAppUrl("/sign-up")}
          fallbackRedirectUrl={resolveAppUrl("/")}
          appearance={{
            elements: {
              rootBox: "w-full",
              card: "shadow-lg",
            },
          }}
        />
      </div>
    </div>
  );
}
